import React from 'react';
import { Loader2, CheckCircle, Star } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { FORMAT_LABELS } from './constants';

export const ExportCard = ({ option, exporting, exportProgress, onExport }) => (
  <div
    className={`bg-white rounded-xl border ${option.comingSoon ? 'border-dashed border-slate-200 opacity-60' : 'border-border'} p-4 hover:shadow-md transition-shadow`}
    data-testid={`export-card-${option.id}`}
  >
    <div className="flex items-start gap-3 mb-3">
      <div
        className="w-10 h-10 rounded-lg flex items-center justify-center"
        style={{ backgroundColor: `${option.color}15` }}
      >
        <option.icon size={20} style={{ color: option.color }} />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <h4 className="font-semibold text-foreground">{option.title}</h4>
          {option.popular && (
            <span className="text-[10px] bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full flex items-center gap-1">
              <Star size={10} className="fill-amber-500" />
              Popular
            </span>
          )}
          {option.comingSoon && (
            <span className="text-[10px] bg-slate-100 text-slate-500 px-2 py-0.5 rounded-full">Coming Soon</span>
          )}
        </div>
        <p className="text-sm text-muted-foreground">{option.description}</p>
      </div>
    </div>

    {!option.comingSoon && (
      <div className="flex flex-wrap gap-2">
        {option.formats.map(format => {
          const formatInfo = FORMAT_LABELS[format];
          const isExporting = exportProgress?.type === option.id && exportProgress?.format === format;

          return (
            <Button
              key={format}
              variant="outline"
              size="sm"
              disabled={exporting}
              onClick={() => onExport(option.id, format)}
              className="flex items-center gap-1.5"
              data-testid={`export-${option.id}-${format}`}
            >
              {isExporting ? (
                <>
                  {exportProgress.status === 'complete' ? (
                    <CheckCircle size={14} className="text-green-500" />
                  ) : (
                    <Loader2 size={14} className="animate-spin" />
                  )}
                  <span>{exportProgress.status === 'complete' ? 'Done!' : 'Exporting...'}</span>
                </>
              ) : (
                <>
                  <formatInfo.icon size={14} />
                  <span>{formatInfo.label}</span>
                </>
              )}
            </Button>
          );
        })}
      </div>
    )}
  </div>
);
